import type { AuctionState } from '@autobid/ui/types/AuctionState'
import type { BarometerCar, CarsListCar, SearchListCar } from '@autobid/ui/types/Car'
import type { Ref } from 'vue'
import { useAuction } from '@autobid/ui/composables/useAuction'
import { computed, unref } from 'vue'

export function useCurrentAuctionState(
  car?: Ref<CarsListCar | SearchListCar | BarometerCar | undefined>,
): AuctionState {
  /*
    do not fetch to prevent make a request multiple times when there are cars from different auctions rendered,
    e.g. list of searched cars - for car list it's already prefetched earlier
  */
  const { auction } = useAuction(unref(car)?.auctionId, {
    enabled: false,
  })

  const isSold = computed(() => {
    return unref(car)?.state === 'SOLD'
  })

  const isNotSold = computed(() => {
    return unref(car)?.state === 'NOT_SOLD'
  })

  const isUnderReservation = computed(() => {
    return unref(car)?.state === 'RESERVED'
  })

  const isUnderAuctionReservation = computed(() =>
    !!auction.value?.activeStatusesNames?.includes('reserve_price_auction'),
  )

  const isPriceDissolution = computed(() =>
    !!auction.value?.activeStatusesNames?.includes('reserve_price_dissolution'),
  )

  return computed(() => ({
    isSold: isSold.value,
    isNotSold: isNotSold.value,
    isUnderReservation: isUnderReservation.value,
    isUnderAuctionReservation: isUnderAuctionReservation.value,
    isPriceDissolution: isPriceDissolution.value,
  }))
}
